<div class="box">
  <div class="modal-header">
    <h2 class="modal-title pull-left mr-4">
      {{ (item?.id ? 'EDIT_ADDRESS_TITLE' : 'NEW_ADDRESS_TITLE') | translate }}
    </h2>
    <button
      type="button"
      class="close pull-right"
      title="{{ 'CLOSE' | translate }}"
      [attr.aria-label]="'CLOSE' | translate"
      (click)="hide()"
    ></button>
  </div>

  <div class="modal-body">
    @if (form) {
      <form #formEl [formGroup]="form" spellcheck="false" autocomplete="off">
        <div class="form-control">
          <label for="type_pa">{{ 'ADDRESS_TYPE_TITLE' | translate }}</label>
          <select id="type_pa" formControlName="type">
            <option selected hidden value="">
              {{ 'ADDRESS_TYPE_PLACEHOLDER' | translate }}
            </option>
            @for (type of types; track trackByFn($index, type)) {
              @if (isLegal ? true : type !== 'legal_address') {
                <option [value]="type">
                  {{ type.toLocaleUpperCase() | translate }}
                </option>
              }
            }
          </select>
          <app-control-errors control="type"></app-control-errors>
        </div>
        @if (isLegal) {
          <div class="form-control">
            <label for="name">{{ 'RECEIVER_NAME' | translate }}</label>
            <input
              type="text"
              id="name"
              formControlName="name"
              [placeholder]="'RECEIVER_NAME_PLACEHOLDER' | translate"
            />
            <app-control-errors control="name"></app-control-errors>
          </div>
        } @else {
          <div class="form-control">
            <label for="last_name_address">{{
              'RECEIVER_LAST_NAME' | translate
            }}</label>
            <input
              type="text"
              id="last_name_address"
              formControlName="last_name"
              [placeholder]="'RECEIVER_LAST_NAME_PLACEHOLDER' | translate"
            />
            <app-control-errors control="last_name"></app-control-errors>
          </div>
          <div class="form-control">
            <label for="first_name_address">{{
              'RECEIVER_FIRST_NAME' | translate
            }}</label>
            <input
              type="text"
              id="first_name_address"
              formControlName="first_name"
              [placeholder]="'RECEIVER_FIRST_NAME_PLACEHOLDER' | translate"
            />
            <app-control-errors control="first_name"></app-control-errors>
          </div>
          <div class="form-control">
            <label for="second_name_address">{{
              'RECEIVER_SECOND_NAME' | translate
            }}</label>
            <input
              type="text"
              id="second_name_address"
              formControlName="second_name"
              [placeholder]="'RECEIVER_SECOND_NAME_PLACEHOLDER' | translate"
            />
            <app-control-errors control="second_name"></app-control-errors>
            <app-control-errors control="form"></app-control-errors>
          </div>
        }
        <div class="form-control radio-list">
          <div class="radio">
            <input
              type="radio"
              name="address_type"
              id="address_radio-modal"
              [asterisk]="false"
              formControlName="address_type"
              value="address"
            />
            <label class="radio__label" for="address_radio-modal">
              <div class="radio__el"></div>
              <span>{{
                'BATCH_MAILING.RECIPIENTS_TAB.ADDRESS_TYPE_ADDRESS' | translate
              }}</span>
            </label>
          </div>
          <div class="radio">
            <input
              type="radio"
              name="address_type"
              [asterisk]="false"
              id="on_demand-modal"
              formControlName="address_type"
              value="on_demand"
            />
            <label class="radio__label" for="on_demand-modal">
              <div class="radio__el"></div>
              <span>{{
                'BATCH_MAILING.RECIPIENTS_TAB.ADDRESS_TYPE_ON_DEMAND'
                  | translate
              }}</span>
            </label>
          </div>
          <div class="radio">
            <input
              type="radio"
              name="address_type"
              id="subscriber_box-modal"
              [asterisk]="false"
              formControlName="address_type"
              value="subscriber_box"
            />
            <label class="radio__label" for="subscriber_box-modal">
              <div class="radio__el"></div>
              <span>{{
                'BATCH_MAILING.RECIPIENTS_TAB.ADDRESS_TYPE_SUBSCRIBER_BOX'
                  | translate
              }}</span>
            </label>
          </div>
        </div>
        <app-create-delivery-location
          [searchUrl]="
            form.get('address_type').value !== 'address' ? 'ops' : 'postcodes'
          "
          [formGroup]="form"
          [queryParams]="{
            batch_mailing_recipient_address_type:
              form.get('address_type').value,
          }"
          [showFullAddress]="form.get('address_type').value === 'address'"
          [findIndexLink]="true"
          class="form-control"
        ></app-create-delivery-location>
        @if (form.get('address_type').value === 'subscriber_box') {
          <div class="form-control">
            <label for="cell_number">{{
              'BATCH_MAILING.RECIPIENTS_TAB.RECIPIENT_CELL_NUMBER' | translate
            }}</label>
            <input
              id="cell_number"
              formControlName="cell_number"
              [placeholder]="
                'BATCH_MAILING.RECIPIENTS_TAB.RECIPIENT_CELL_NUMBER_PLACEHOLDER'
                  | translate
              "
            />
            <app-control-errors control="cell_number"></app-control-errors>
          </div>
        }
        <div class="form-control">
          <label for="note_pa">{{ 'NOTE' | translate }}</label>
          <textarea
            formControlName="comment"
            id="note_pa"
            cols="30"
            rows="10"
            placeholder="{{ 'NOTE_PLACEHOLDER' | translate }}"
          ></textarea>
          <app-control-errors control="comment"></app-control-errors>
        </div>
        @if (!item.id || !item.is_default) {
          <div class="form-control">
            <div class="checkbox">
              <input
                type="checkbox"
                id="is_default_pa"
                formControlName="is_default"
              />
              <label for="is_default_pa">
                <div class="checkbox__el"></div>
                <div class="checkbox__desc">
                  <p class="h3">{{ 'SET_DEFAULT_TITLE' | translate }}</p>
                </div>
              </label>
            </div>
          </div>
        }
      </form>
    }
  </div>

  @if (error) {
    <div class="error text-danger">{{ error.error.message }}</div>
  }

  <div class="modal-footer modal-footer--right">
    <button
      type="button"
      class="button button--outlined"
      (click)="hide('cancel')"
    >
      {{ 'CANCEL' | translate }}
    </button>

    <button
      [tooltip]="form.invalid ? ('CHECK_THE_FORM' | translate) : ''"
      [class.disabled]="form.invalid"
      class="button button--filled button--shadow"
      type="button"
      placement="bottom"
      (click)="sendForm()"
    >
      @if (!isLoading) {
        <span>{{ 'SAVE' | translate }}</span>
      } @else {
        <span
          class="spinner-border spinner-border-sm"
          role="status"
          aria-hidden="true"
        ></span
        >&nbsp;
        <span>{{ 'SENDING' | translate }}...</span>
      }
    </button>
  </div>
</div>
